import React, { useEffect, useRef, useState } from "react";
import { withTranslation, useTranslation } from "react-i18next";
import ImageSection from "../ImageSection";
import "./FeaturesPlatform.css";

/* ── Iconos SVG por feature ── */
const FEATURE_ICONS = {
  1: (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M9 9h6M9 13h6M9 17h4" />
      <circle cx="18" cy="5" r="3" fill="#4ade80" stroke="#4ade80" strokeWidth="1.5" />
    </svg>
  ),
  2: (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 01-3.46 0" />
      <circle cx="18" cy="4" r="2.5" fill="#f97316" stroke="#f97316" strokeWidth="1" />
    </svg>
  ),
  3: (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2.69l5.66 5.66a8 8 0 11-11.31 0L12 2.69z" />
      <path d="M12 13v4" />
      <path d="M10 17h4" />
    </svg>
  ),
  4: (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
};

/* ── Feature card individual ── */
const FeatureCard = ({ index, data, t, visible }) => {
  return (
    <div
      className="xAgro-fp-card col-md-6 mt-3"
      style={{ transitionDelay: `${index * 100 + 150}ms` }}
      data-visible={visible}
    >
      <div className="xAgro-fp-card-inner">
        <div className="xAgro-fp-icon">
          {FEATURE_ICONS[index]}
        </div>
        <h4>{t(`${data}.feature_${index}_title`)}</h4>
        <span>{t(`${data}.feature_${index}_content`)}</span>
      </div>
    </div>
  );
};

/* ── Componente principal ── */
const Features = ({ data }) => {
  const [t] = useTranslation("common");
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div id="xAgro-features-platform" ref={sectionRef}>
      <div className="xAgro-fp-wrapper">
        <div className="row xAgro-fp-row">

          {/* ── Columna izquierda: texto + features ── */}
          <div className="col-12 col-md-7 d-flex flex-column xAgro-fp-content">

            <h1
              className="xAgro-features-platform-title"
              data-visible={visible}
            >
              {t(`${data}.title`)}
            </h1>

            <h3
              className="xAgro-features-platform-text"
              data-visible={visible}
            >
              {t(`${data}.text`)}
            </h3>

            <div className="row xAgro-features-platform-container">
              {[1, 2, 3, 4].map((i) => (
                <FeatureCard
                  key={i}
                  index={i}
                  data={data}
                  t={t}
                  visible={visible}
                />
              ))}
            </div>
          </div>

          {/* ── Columna derecha: imagen dashboard ── */}
          <div className="col-12 col-md-5 xAgro-fp-image-col">
            <div
              className="xAgro-fp-image-container"
              data-visible={visible}
            >
              <div className="xAgro-fp-image-glow" />
              <ImageSection data={data} />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default withTranslation("common")(Features);